import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Flex,
} from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";

export default function SymptomsTable({ data }) {
  const navigate = useNavigate();
  return (
    <Table caption="" highlightOnHover={true} variation="striped">
      <TableHead>
        <TableRow>
          <TableCell as="th">Symptom</TableCell>
          <TableCell as="th">Start Date</TableCell>
          <TableCell as="th">End Date</TableCell>
          <TableCell as="th">Action</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data &&
          data.map((item) => (
            <TableRow key={item.id}>
              <TableCell>{item.symptom}</TableCell>
              <TableCell>{item.symptomStartDate}</TableCell>
              <TableCell>{item.symptomEndDate}</TableCell>
              <TableCell>
                <Flex direction="row" alignItems="center" gap={6}>
                  <Button
                    variation="link"
                    onClick={() => {
                      navigate(
                        `/user/quick-actions/overall-symptoms/${item.id}/edit`
                      );
                    }}
                  >
                    View
                  </Button>
                </Flex>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}
